<script setup>
import { inject, ref } from 'vue';
import { logout } from '../actions/appActions';
import Payment from '../payments/Payment.vue';
import Icon from '../Icon.vue';
import { placeholdAction } from '../editor/actions/placeholderAction';
import { newDocument, newWizard } from '../actions/documentActions';
import { redirectToStripePortal } from '../payments/paymentActions';
import BillingCredit from '@/payments/BillingCredit.vue';
import BillingDialog from '../payments/BillingDialog.vue';

  const userInfo = inject('userInfo')
  const showDialog = inject('showDialog')

  const confirmationTask = inject('confirmationTask')
  function logoutConfirming() {
    confirmationTask.value = {
      text: "You're about to log out. Do you want to continue?",
      onOK: logout
    }
  }

</script>
<template>

  <div class="flex flex-col gap-2 items-strtech">
    <span class="item selectable justify-start gap-3" @click="showDialog('Billing')"><Icon :size="16" name="streamline--subscription-cashflow"/> billing...</span>
    <span class="only-mobile item selectable justify-start gap-3" @click="newWizard"><Icon :size="16" name="wand"/> write with AI </span>
    <span class="only-mobile item selectable justify-start gap-3" @click="() => newDocument(userInfo.uid)"><Icon :size="16" name="heroicons--plus"/> empty doc</span>


    <span class="item selectable text-error justify-start gap-3" @click="logoutConfirming"><Icon :size="16" name="ic--baseline-logout"/> log out </span>
    <div class="border-t my-2  border-base-content/20"></div>
    <div class="flex gap-3 item selectable item-navigable" @click="placeholdAction">
      <Icon :size="32" name="bi--person-fill-gear"/>
      <div class="flex flex-col items-end">
        <div>{{ userInfo.name }}</div>
        <div>{{ userInfo.email }}</div>        
      </div>
    </div>
    <div class="border-t my-2  border-base-content/20"></div>

    <div class="text-xs flex justify-center"> <BillingCredit :extended="true"/> </div>

  </div>
</template>
<style lang="less" scoped>
.only-mobile {

  @media (min-width: @screen-md) {
    & {
      display: none;
    }
  }

}
</style>
